const sectorPlx = {
	el: document.querySelector(".atk-sectors-carousel"),
	load: function () {
		if (window.ScrollTrigger) {
			sectorPlx.set();
		} else {
			if (window.utils.screen.width < window.utils.breakpoint.lg) {
				if (window.gsap) {
					window.utils.loadScript(
						window.baseUrl + "/js/external/gsap-scrolltrigger.min.js",
						false,
						function () {
							gsap.registerPlugin(window.ScrollTrigger);
							sectorPlx.set();
						},
						true
					);
				} else {
					setTimeout(function () {
						sectorPlx.load();
					}, 100);
				}
			} else {
				setTimeout(function () {
					sectorPlx.load();
				}, 100);
			}
		}
	},
	set: function () {
		sectorPlx.el
			.querySelectorAll(".container>.row")
			.forEach(function (el, index) {
				sectorPlx.translate(el, index);
				// sectorPlx.observer.observe(el);
			});
	},
	observer: new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting || entry.intersectionRatio > 0) {
				if (!entry.target.hasAttribute("running")) {
					entry.target.setAttribute("running", "");
				}
			} else {
				if (entry.target.hasAttribute("running")) {
					entry.target.removeAttribute("running");
				}
			}
		});
	}),
	translate: function (el, index) {
		let snapObj = {
			snapTo: "labels", //labelsDirectional
			duration: { min: 0.1, max: 0.6 },
			delay: 0.2,
			ease: "power1.inOut",
		};
		gsap
			.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top+=" + window.utils.screen.height * 0.4 + "px bottom",
					end: "bottom+=" + window.utils.screen.height * 0.6 + "px bottom",
					scrub: 1.4,
					snap: snapObj,
				},
			})
			.to(el.querySelector(".inner-block"), {
				autoAlpha: 1,
				duration: 1,
				ease: "none",
			})
			.addLabel("start" + index, ">")
			.to(el.querySelector(".inner-block"), {
				autoAlpha: 0,
				duration: 1,
				ease: "none",
			})
			.to(
				el.querySelectorAll(".bkg"),
				{
					y: -window.utils.screen.height,
					duration: 2,
					ease: "none",
				},
				"-=2"
			)
			.to(
				el.querySelectorAll(".bkg"),
				{
					autoAlpha: 0,
					duration: 1,
					ease: "none",
				},
				"-=1"
			);
	},
	init: function () {
		if (sectorPlx.el) {
			sectorPlx.load();
		}
	},
};

sectorPlx.init();
